import { ClerkProvider } from '@clerk/react';
import { localStorageStore } from 'ra-core';
import { queryClient } from './App';
import { LoggedInGuard } from './auth/LoggedInGuard';
import { useReactAdminProviders } from './auth/useReactAdminProviders';
import { AppLoading } from './components/AppLoading';
import { useMoonstarI18nProvider } from './i18n/i18nProvider';
import { MoonstarLayout } from './layout/Layout';
import { Admin } from './routes/Admin';
import { CurrentUserProvider } from './auth/currentUserContext';
import { clerkAppearance } from './auth/clerkAppearance';

const clerkKey = import.meta.env.VITE_CLERK_FRONTEND_API;
const store = localStorageStore();

export const AdminApp = () => {
  return (
    <ClerkProvider
      signInUrl="/"
      signUpUrl="/"
      publishableKey={clerkKey}
      signInFallbackRedirectUrl="/"
      appearance={clerkAppearance}
    >
      <LoggedInGuard>
        <AuthenticatedAdmin />
      </LoggedInGuard>
    </ClerkProvider>
  );
};

const AuthenticatedAdmin = () => {
  const { isLoading, isError, authProvider, dataProvider, user } =
    useReactAdminProviders();
  const i18nProvider = useMoonstarI18nProvider();

  if (isLoading) {
    return <AppLoading />;
  } else if (isError) {
    return <AppLoading isError />;
  }

  return (
    <CurrentUserProvider value={user}>
      <Admin
        requireAuth
        authProvider={authProvider}
        dataProvider={dataProvider}
        i18nProvider={i18nProvider}
        layout={MoonstarLayout}
        queryClient={queryClient}
        store={store}
      />
    </CurrentUserProvider>
  );
};
